// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AddProductButton-module-addProductButtonWrapper-3Hfs4{position:relative}.AddProductButton-module-addProductButtonLoader-2IRhl{height:45px}.AddProductButton-module-addProductButtonWrapperMobileContent-1nV6H{margin-block-start:12px}.AddProductButton-module-mobileViewPrice-n8Z-R{font-size:14px;font-weight:var(--weight-medium);letter-spacing:1.5px;line-height:20px}.AddProductButton-module-button-cT3Ct{width:100%}@media(min-width: 960px){.AddProductButton-module-button-cT3Ct{width:auto}}", ""]);
// Exports
exports.locals = {
	"addProductButtonWrapper": "AddProductButton-module-addProductButtonWrapper-3Hfs4",
	"addProductButtonLoader": "AddProductButton-module-addProductButtonLoader-2IRhl",
	"addProductButtonWrapperMobileContent": "AddProductButton-module-addProductButtonWrapperMobileContent-1nV6H",
	"mobileViewPrice": "AddProductButton-module-mobileViewPrice-n8Z-R",
	"button": "AddProductButton-module-button-cT3Ct"
};
module.exports = exports;
